import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createPeopleMerge } from 'services/merge'
import { transformJobMappingsForAPI } from '../utils'
import { useHistory } from 'react-router-dom'
import { useNotification } from 'components/Notification'
import { ENTITY_MERGE_RECORDS_QUERY_KEY } from '../constants'

function usePeopleMergeMutation() {
  const history = useHistory()
  const queryClient = useQueryClient()
  const { createNotification } = useNotification()

  const { mutate: merge, isLoading, isError, error } = useMutation(
    ({ sourceId, targetId, jobMappings, jobOverrides, isRetry }) => {
      // For retry, data is already in API format; for new merge, transform it
      if (isRetry) {
        return createPeopleMerge(sourceId, targetId, jobMappings, jobOverrides)
      }
      const { jobMappings: apiMappings, jobOverrides: apiOverrides } = transformJobMappingsForAPI(
        jobMappings,
      )
      return createPeopleMerge(sourceId, targetId, apiMappings, apiOverrides)
    },
    {
      retry: false,
      onSuccess: (_, { isRetry }) => {
        createNotification({
          message: isRetry
            ? 'Merge retry has been initiated successfully'
            : 'Merge process has been initiated successfully',
          variant: 'success',
        })
        queryClient.invalidateQueries([ENTITY_MERGE_RECORDS_QUERY_KEY])
        if (!isRetry) {
          history.push('/merge-profiles/people')
        }
      },
      onError: error => {
        createNotification({
          message:
            error?.response?.data?.errors?.map(e => e.message).join(', ') || 'Failed to merge',
          variant: 'error',
        })
      },
    },
  )

  return {
    merge,
    isLoading,
    isError,
    error,
  }
}

export default usePeopleMergeMutation
